import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h4>@2023 #VANLIFE</h4>
    </div>
  );
};

export default Footer;
